import React, { PropsWithChildren } from "react";
import { ReactComponent as Court } from "../assets/football-court.svg";

export function PitchLayout({
  children,
  heightVw,
}: PropsWithChildren<{ heightVw?: number }>) {
  const resolvedHeight = heightVw ? `${heightVw}vw` : "50vw";

  return (
    <div className="flex w-full flex-col">
      <div
        className="relative w-full min-h-[150px]"
        style={{ height: resolvedHeight }}
      >
        <Court className="pointer-events-none absolute inset-0 z-[1] h-full w-full select-none" />
        <div className="relative z-[2] h-full w-full">{children}</div>
      </div>
    </div>
  );
}
